import Vue from 'vue';
import foot from './footer.vue';
import headNav from './header.vue';
import request from '../utils/request';
export default Vue.extend({
    name: 'home',
    components: {
        foot: foot,
        headNav: headNav,
    },
    data: function () {
        var phoneValidate = function (rule, value, callback) {
            var re = /^[1]{1}[3,4,5,7,8]{1}[0-9]{9}$/;
            if (value && !re.test(value)) {
                return callback(new Error('手机号格式不正确'));
            }
            else {
                callback();
            }
        };
        return {
            activeIndex: 1,
            contact: {},
            rules: {
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                contactPhone: [
                    { required: true, message: '请输入联系人电话', trigger: 'blur' },
                    { validator: phoneValidate, trigger: 'blur' },
                ],
            },
        };
    },
    created: function () { },
    methods: {
        getCampaignList: function () { },
        goto: function () {
            this.$router.push('/console/contract/import');
        },
        handleSelect: function (key, keyPath) { },
        submitForm: function (formName) {
            var _this = this;
            this.$refs[formName].validate(function (valid) {
                if (!valid)
                    return;
                var data = _this.contact;
                data.type = 2;
                request({
                    method: 'post',
                    url: '/proxy/api/clue/add',
                    data: data,
                }).then(function (res) {
                    if (!res)
                        return;
                    if (!res.errorCode) {
                        _this.$message({
                            message: '提交信息成功，我们三个工作日内会与您联系',
                            type: 'success',
                        });
                    }
                });
            });
        },
        cancel: function (formName) {
            this.$refs[formName].resetFields();
        },
    },
});
